define('module/team-wall',[
    'underscore',
    'jquery',
    'cnf',
    '_pubsub'
], function(_,$,Cnf,Pubsub){
    'use strict';
    
    var oPubsub=new Pubsub;
    
    return function()
    {
        this.options={
            selector:{
                trigger:'.trigger-team-wall',
                item:'.trigger-team-wall-item',
                text:'.team-text'
            },
            data:{
                index:'index',
                active:'active',
                uniqueid:'uniqueid',
                teamid:'teamid'
            },
            tween: {
                duration:.5,
                easeIn:Power2.easeInOut,
                easeOut:Power2.easeInOut,
                labelBreakeven:'team-wall-breakeven',
                labelEnd:'team-wall-end'
            }
        };
        
        this.init=function()
        {
            this.initOptions();
            this.initEvent();
            this.initElement();
        };
        
        this.initOptions=function()
        {
            this.$teamwall=Cnf.$app.find(this.options.selector.trigger);
            this.iTeamwall=this.$teamwall.length;
            this.oTeamwall={};
            this.iId=0;
            this.oId={};
            this.oTl={};
        };
        
        this.initEvent=function()
        {
            oPubsub.on(Pubsub.FLICKITY_STATICCLICK, _.bind(this.onFlickityClick,this));
            oPubsub.on(Pubsub.VIEWPORT_CHANGE,_.bind(this.onViewportChange,this));
        };
        
        this.initElement=function()
        {
            
            if(this.iTeamwall<=0) {
                return;
            }
            
            var i, y, $item, iItem;
            
            for(i=0;i<this.iTeamwall; i++) {
                this.$teamwall.eq(i).attr('data-' + this.options.data.teamid, i);
                $item=this.$teamwall.eq(i).find(this.options.selector.item),
                        iItem=$item.length;
                
                for(y=0;y<iItem;y++) {
                    $item.eq(y)
                            .attr('data-' + this.options.data.teamid, i)
                            .on(Cnf.click, _.bind(this.onClick, this, iItem));
                }
                
                //set relation from global index to internal index
                this.oTeamwall[this.$teamwall.eq(i).attr('data-' + this.options.data.index)]=i;
            }
        };
        
        /**
         * @jira FDZ-617
         * @updated 2023-01-13
         * @author sh@sopg.de
         * 
         * @param {int} iLength
         * @param {object} ev 
         */
        this.onClick=function(iLength, ev)
        {
            if(
                (Cnf.isMobile===false) 
                || (iLength === 1)
            ) {
                this.toggle(ev);
            }
        };
        
        this.toggle=function(ev)
        {
            if(ev.currentTarget.dataset[this.options.data.active]==='true') {
                this.hide(ev);
            } else {
                this.show(ev);
            }
        };
        
        this.hide=function(ev)
        {
            var $el=$(ev.currentTarget);
            
            $el.attr('data-' + this.options.data.active, 'false');
            
            this.tl(ev).tweenTo(this.options.tween.labelEnd);
        };
        
        this.show=function(ev)
        {
            var $el=$(ev.currentTarget);
            
            $el.attr('data-' + this.options.data.active, 'true');
            this.tl(ev).tweenTo(this.options.tween.labelBreakeven);
            
        };
        
        this.getId=function(ev)
        {
            if(typeof this.oId[ev.currentTarget.dataset[this.options.data.uniqueid]]==='undefined') {
                ev.currentTarget.dataset[this.options.data.uniqueid]=ev.currentTarget.dataset[this.options.data.teamid] + ':' + this.iId;
                this.oId[ev.currentTarget.dataset[this.options.data.uniqueid]]=ev.currentTarget.dataset[this.options.data.teamid] + ':' + this.iId;
                this.iId++;
            }
            
            return this.oId[ev.currentTarget.dataset[this.options.data.uniqueid]];
        };
        
        this.tl=function(ev)
        {
            var oTimeline,
                    id=this.getId(ev);
            
            if(typeof this.oTl[id]==='undefined') {
                var $el=$(ev.currentTarget),
                        $text=$el.find(this.options.selector.text),
                        iHeight=$text.height();
                
                oTimeline=new TimelineMax({paused:true});
                
                oTimeline.set($text, {
                    height:0,
                    position:'relative'
                });
                
                oTimeline.to($text, this.options.tween.duration,
                {
                    height:iHeight,
                    ease:this.options.tween.easeIn
                });
                
                oTimeline.set($text, {
                    height:'auto'
                });
                
                oTimeline.addLabel(this.options.tween.labelBreakeven);
                
                oTimeline.to($text, this.options.tween.duration, {
                    height:0,
                    ease:this.options.tween.easeOut
                });
                
                oTimeline.set($text, {
                    height:'auto',
                    position:'absolute'
                });
                
                oTimeline.addLabel(this.options.tween.labelEnd);
                
                this.oTl[id]=oTimeline;
            } else {
                oTimeline=this.oTl[id];
            }
            
            return oTimeline;
        };
        
        this.onFlickityClick=function(data)
        {
            if(
                    (data.name===Cnf.dataFlickityCallback)
                    && (data.value==='team_wall')
            ) {
                var $item=this.$teamwall.eq(this.oTeamwall[parseInt(data.attributes['data-index'])]).find(this.options.selector.item);
                if($item.length>0) {
                    this.toggle({currentTarget:$item.eq(data.index)[0]});
                }
            }
        };
        
        /**
         * callback on pubsub viewport change
         * 
         * @param {type} ev
         * @returns {undefined}
         */
        this.onViewportChange=function(ev)
        {
            switch(true) {
                case ev.previous==='mobile':
                    this.init();
                    break;
                    
                default:break;
            }
        };
        
        this.init();
    };
});


